<template>
  <div class="d-flex align-center">
    <v-img
      v-if="IMGS.includes(card.brand)"
      class="mr-3"
      style="width: 24px;"
      :aspect-ratio="1"
      :src="`/credit-cards/${card.brand}.png`"
    />
    <span v-else class="mr-1">card.brand</span>
    *{{card.last_4}}
  </div>
</template>

<script>
export default {
  name: 'credit-card-preview',
  props: [ 'card' ],
  created() {
    this.IMGS = [ 'amex', 'discover', 'mastercard', 'visa' ];
  }
}
</script>
